import React from "react";
import "../../css/components/Services.css";
import Investing from "../../assets/images/Investing.jpg"; // Replace with actual image paths
import CriticalIllness from "../../assets/images/CriticalIllness.jpg"; // Replace with actual image paths
import HomeOwnership from "../../assets/images/HomeOwnership.jpg"; // Replace with actual image paths
import LegacyLifeProtection from "../../assets/images/Legacy.jpg";
import IncomeProtection from "../../assets/images/IncomeProtection.jpg";
import BuildYourPlan from "../../assets/images/BuildYourPlan.jpg";
import TertiaryButton from "../components/buttons/TertiaryButton";
import PrimaryButton from "../components/buttons/PrimaryButton";
import SecondaryButton from "../components/buttons/SecondaryButton";
import { useNavigate } from "react-router-dom";

const services = [
  {
    number: "01",

    title: "Investing",
    subtitle: "Put your<br/> money</br/> to work",
    image: Investing,
    description:
      "Saving erodes value. Investing builds it. Your money should operate with the same discipline you do — purposeful, active, performing under  pressure. Start from £50 a month.",
  },
  {
    number: "02",
    title: "Critical illness & recovery",
    subtitle: "your safety<br/> net. your<br/>second line",
    image: CriticalIllness,
    description:
      "Critical illness doesn't just affect your health. It hits your career, your income, your family. This is the coverage that keeps everything standing when you can't.",
  },
  {
    number: "03",
    title: "home ownership",
    subtitle: "A base <br/>worth coming <br/>back to",
    image: HomeOwnership,
    description:
      "Posted away for months at a time. Still building towards something  permanent. The Plan UK navigates Forces Help to Buy, lenders who  understand service life, and the mortgage market — on your behalf.",
  },
  {
    number: "04",
    title: "legacy & life protection",
    subtitle: "what you <br/>leave behind<br/>matters",
    image: LegacyLifeProtection,
    description:
      "You've accepted the risk. Your family shouldn't have to accept the  consequences. Life protection built around the realities of service —  giving the people who matter a foundation to stand on, whatever happens.",
  },
  {
    number: "05",
    title: "income protection",
    subtitle: "their income.<br/>your <br/>responsibility.",
    image: IncomeProtection,
    description:
      "You've accepted the risk. Your family shouldn't have to accept the  consequences. Life protection built around the realities of service —  giving the people who matter a foundation to stand on, whatever happens.",
  },
  {
    // number: "06",
    title: "ready to start",
    subtitle: "",
    subtitleBold: "build<br/>your plan",
    showButton: true,
    image: BuildYourPlan,
    description: "",
  },
];

const Services = () => {
  const navigate = useNavigate();
  return (
    <div className="services-grid" id="who-we-cover">
      {services.map((service, idx) => (
        <div
          className={`service-card${service.showButton ? " no-overlay" : ""}`}
          key={idx}
          style={{
            backgroundImage: `url(${service.image})`,
          }}
        >
          <div className="service-content">
            {(service.number || service.title) && (
              <div className="service-header">
                <h4 className="primary">{service.number}</h4>
                <span
                  className={`nav-regular ${service.showButton ? "secondary" : "primary"}`}
                >
                  — {service.title.toUpperCase()}
                </span>
              </div>
            )}
            <div>
              <h2
                className="service-subtitle bold uppercase"
                dangerouslySetInnerHTML={{ __html: service.subtitle }}
              />
              {service.subtitleBold && (
                <h1
                  className={`${service.showButton ? "secondary" : ""}`}
                  dangerouslySetInnerHTML={{ __html: service.subtitleBold }}
                  // {service.subtitleBold.toUpperCase()}
                />
              )}

              <div className="service-hover-details">
                <p className="content">{service.description}</p>
                {/* <SecondaryButton
                text="Start your journey"
                onClick={() => {
                  navigate("/#contact");
                }}
              /> */}
                {service.showButton && (
                  <a href="/#contact">
                    <SecondaryButton
                      text="Create your plan"
                      onClick={() => {
                        navigate("/#contact");
                      }}
                    />
                  </a>
                )}
              </div>
              <div className="find-out-more-area">
                <TertiaryButton
                  color={service.showButton ? "secondary" : "primary"}
                  children={
                    <div
                      className={`nav-regular ${
                        service.showButton ? "secondary" : "primary"
                      }`}
                    >
                      Find out more
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;
